import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Box, Grid, Typography, useMediaQuery, useTheme,} from "@material-ui/core";
import {FormProvider, useForm} from "react-hook-form";

import Loader from "../components/Loader/Loader";
import Forms from "../steps/Step2/organisms/Forms";
import NextButton from "../components/NextButton/NextButton";
import Error from "../components/Error/Error";
import FormOperator from "../components/FormOperator/FormOperator";
import PassengerTab from "../steps/Step2/molecules/PassengerTab";
import CustomPhoneNumber from "../components/CustomPhoneNumber/CustomPhoneNumber";
import CustomTextField from "../components/CustomTextField/CustomTextField";
import {CustomSwitch} from "../components/Switch/Switch";
import PhoneContactIcon from "../assets/img/contact.svg";
import useStyles from "../steps/Step2/styles";
import Accreditation from "../components/Accreditation/Accreditation";
// import testOrderView from '../api/testOrderView';

export default function SecondStepViewPage() {
  const [apiData, setApiData] = useState({});
  const { token, priceQuoteId } = useParams();
  const classes = useStyles();

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (window.userData) {
        setApiData(() => ({
          ...window.userData,
          result: {
            ...window.userData.result,
            passengers: window.userData.result.passengers.map((passenger) => ({
              ...passenger,
              frequentFlyer: passenger.frequentFlyer?.length ? passenger.frequentFlyer : [
                {
                  airline_pk: '',
                  frequent_flyer_number: ''
                }
              ]
            }))
          }
        }))
      }

      // setApiData(testOrderView);
    }

    return () => (mounted = false);
  }, []);

  const methods = useForm({
    shouldUnregister: false,
    defaultValues: apiData?.result,
    resolver: undefined,
    mode: "onChange",
  });

  return (
    <FormProvider {...methods}>
      <form style={{ paddingBottom: "50px", height: "100%" }}>
        <Grid container style={{ height: "100%" }}>
          {typeof apiData === "object" && Object.keys(apiData).length > 1 ? (
            <SecondStepViewForm classes={classes} apiData={apiData} />
          ) : (
            <Grid container>
              <Grid item xs={12} className={classes.mainForm}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  {typeof apiData === "string" ? (
                    <Typography variant="h2">{apiData}</Typography>
                  ) : (
                    <Loader />
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
      </form>
    </FormProvider>
  );
}

const SecondStepViewForm = ({ classes, apiData }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const theme = useTheme();
  const show = useMediaQuery(theme.breakpoints.down("sm"));

  const selectedFlight = apiData?.priceQuotes.find(
    (item) => item.id == apiData?.result?.flight
  );

  if (!selectedFlight?.parts?.multiple) {
    delete selectedFlight?.parts?.multiple
  }

  const calcGridSize = (items) => {
    if (items > 3) {
      return 3;
    }
    if (items === 3) {
      return 4;
    }
    return 6;
  };
  const gridSize = calcGridSize(apiData?.result?.passengers?.length);

  const handlePrevAction = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const handleNextAction = () => {
    if (activeIndex < apiData?.result?.passengers?.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };
  return (
    <>
      <Grid item xs={12} md={8} className={classes.mainForm}>
        <Box
          key={`first`}
          mb={2.5}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.formHeader}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography variant="h1" align="center">
              Passenger details
            </Typography>
          </Box>
        </Box>
        <Box
          mt={1}
          mb={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Error
            errorMessage="Passenger names must be entered exactly as in the passport or a government issued ID. Name changes are not permitted after booking."
          />
        </Box>



        {apiData?.result?.passengers.map((fieldEmpty, activeIndex) => (
          <Box key={`${activeIndex}a`}>
            {apiData?.result?.passengers?.length > 1 && (
              <Grid container spacing={1} className={classes.tabSection}>
                {apiData?.result?.passengers.map((field, idx) => (
                  <Grid key={field?.id} item xs={12} sm={gridSize}>
                    <PassengerTab
                      index={idx}
                      field={field}
                      isActive={idx === activeIndex}
                      remove={() => { }}
                      setActiveIndex={setActiveIndex}
                      showDelete={false}
                      errors={[]}
                      resetActiveIndex={() => setActiveIndex(0)}
                      passengersValues={apiData?.result?.passengers}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
            <Box key={`${activeIndex}b`}>
              {apiData?.result?.passengers?.map((field, index) => (
                <Forms
                  key={field}
                  field={field}
                  index={index}
                  activeFormIndex={activeIndex}
                  handlePrevAction={handlePrevAction}
                  handleNextAction={handleNextAction}
                  currentValues={field}
                  extras={apiData?.extras}
                  airlines={apiData.airlines}
                  selectedFlight={selectedFlight}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Grid>
      <Grid item xs={12} md={4} className={classes.secondaryForm}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.contactBox}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={{ xs: 1, sm: 2 }}
            className={classes.icon}
          >
            <img src={PhoneContactIcon} alt="phone" />
          </Box>
          <Typography variant="h3">Contact Details</Typography>
          <Typography variant="body1" align="center">
            By providing my contact details I agree to be contacted in regards
            to this booking via phone, text and email.
          </Typography>
          <Box mt={2}>
            <CustomTextField label="E-mail" name="email" />
            <CustomPhoneNumber
              name="contactPhoneNumber"
              defaultValue={apiData?.result?.contactPhoneNumber}
            />
          </Box>
          <Box mb={1} mt={{ xs: 3, sm: 1 }}>
            <CustomSwitch
              name="contactDetailsSwitch"
              value={apiData?.result?.contactDetailsSwitch}
              defaultValue={apiData?.result?.contactDetailsSwitch}
              label="I confirm that the passenger details are correct"
            />
          </Box>
          {!show && (
            <NextButton
              selectedFlight={selectedFlight}
              tipsValue={apiData?.result?.tips}
              handleNext={() => { }}
              disabled={true}
              location="form"
            />
          )}
        </Box>
        <Box width={1}>
          <FormOperator operatorInfo={apiData?.operatorInfo} />
          <Accreditation isStepTwo={true} />
        </Box>
      </Grid>
    </>
  );
};
